import { GlassCard } from "@/components/GlassCard";
import { pickMessage } from "@/lib/messages";
import { useLanguage } from "@/i18n/LanguageContext";

export const MotivationCard = ({ stats, loading }) => {
  const { t } = useLanguage();

  const message = stats
    ? pickMessage(
        t(stats.today_has_activity ? "messages.after" : "messages.before"),
        stats.activities_this_week
      )
    : "";

  return (
    <GlassCard className="p-5">
      <p className="text-[11px] uppercase tracking-[0.2em] text-cyan-300/70 font-medium mb-2">
        {t("dashboard.todaysCurrent")}
      </p>
      <p
        data-testid="dashboard-motivation-message"
        className="motion-message text-base leading-relaxed font-medium"
      >
        {loading ? "\u00A0" : message}
      </p>
    </GlassCard>
  );
};
